// Migration page to populate database with initial corretores
// Access this page once to migrate data from mockData to Supabase

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
  Alert,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Divider,
} from '@mui/material';
import { migrateCorretores } from '../scripts/migrateCorretores';

function MigrateData() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);

  const handleMigrate = async () => {
    try {
      setLoading(true);
      setError(null);
      setResults(null);

      const migrationResults = await migrateCorretores();
      setResults(migrationResults);
    } catch (err) {
      console.error('Migration error:', err);
      setError(err.message || 'Erro ao migrar dados');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Migração de Dados
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Esta página permite migrar os corretores iniciais para o banco de dados Supabase.
          Os corretores serão criados <strong>sem dados de vendas</strong> (valores em branco).
          Você poderá preencher os valores posteriormente na interface do sistema.
        </Typography>
        <Alert severity="info" sx={{ mb: 3 }}>
          <strong>Importante:</strong> Execute esta migração apenas uma vez. 
          Ela criará os corretores básicos (nome, email, telefone, CRECI, foto) sem valores de vendas.
        </Alert>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {!results && (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Button
              variant="contained"
              size="large"
              onClick={handleMigrate}
              disabled={loading}
              sx={{ mb: 2 }}
            >
              {loading ? (
                <>
                  <CircularProgress size={24} sx={{ mr: 2 }} />
                  Migrando...
                </>
              ) : (
                'Iniciar Migração'
              )}
            </Button>
            {loading && (
              <Typography variant="body2" color="text.secondary">
                Por favor, aguarde...
              </Typography>
            )}
          </Box>
        )}

        {results && (
          <Box>
            <Alert severity="success" sx={{ mb: 2 }}>
              Migração concluída!
            </Alert>

            <Typography variant="h6" gutterBottom>
              Resultados
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Sucessos: {results.success.length} | Erros: {results.errors.length}
            </Typography>

            {results.success.length > 0 && (
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle1" gutterBottom>
                  Corretores Criados:
                </Typography>
                <List dense>
                  {results.success.map((item, index) => (
                    <ListItem key={index}>
                      <ListItemText
                        primary={item.nome}
                        secondary={`ID: ${item.newId}`}
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}

            {results.errors.length > 0 && (
              <Box>
                <Typography variant="subtitle1" gutterBottom color="error">
                  Erros:
                </Typography>
                <List dense>
                  {results.errors.map((item, index) => (
                    <ListItem key={index}>
                      <ListItemText
                        primary={item.nome}
                        secondary={item.error}
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}

            <Divider sx={{ my: 3 }} />

            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
              <Button variant="outlined" onClick={() => navigate('/configuracao')}>
                Ir para Configurações
              </Button>
              <Button variant="contained" onClick={() => window.location.reload()}>
                Recarregar Página
              </Button>
            </Box>
          </Box>
        )}
      </Paper>
    </Container>
  );
}

export default MigrateData;

